import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import CompensationStep from '../../../CompensationContainer/Steps/CompensationStep';
import { updatePropertyForm } from '../../../../redux/modules/propertyClaim';
import { TRANSFER_TYPES_WITHOUT_CASH } from '../../../../constants';

const PropertyCompensationStep = ({
  step,
  goNext,
  goPrevious,
  params: { setStepNavigationBox },
}) => {
  const propertyClaim = useSelector((store) => store.propertyClaim, shallowEqual);

  return (
    <CompensationStep
      step={step}
      goNext={goNext}
      goPrevious={goPrevious}
      setStepNavigationBox={setStepNavigationBox}
      claim={{
        ...propertyClaim,
        compensation: {
          ...propertyClaim.compensation,
          paymentReceiverType: propertyClaim.compensation.paymentReceiverType || 'owner',
        },
      }}
      formLanguage={propertyClaim.language}
      applicantIsAdult
      updateForm={updatePropertyForm}
      transferTypes={TRANSFER_TYPES_WITHOUT_CASH}
      applicantPrimaryOption={{
        primaryLabel: 'claim.personalData.owner',
        primaryValue: 'owner',
      }}
    />
  );
};

PropertyCompensationStep.propTypes = {
  step: PropTypes.shape({
    claimForm: PropTypes.string.isRequired,
    n: PropTypes.number.isRequired,
  }).isRequired,
  goNext: PropTypes.func.isRequired,
  goPrevious: PropTypes.func.isRequired,
  params: PropTypes.shape({
    setStepNavigationBox: PropTypes.func.isRequired,
  }).isRequired,
};

export default PropertyCompensationStep;
